import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
//@ts-ignore
import { awaitableSetTimeout } from "@utils/GenericUtils";
import { defineComponent } from "vue";
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import { CloseIcon } from "@vueEntry/SvgIcons/CloseIcon";
//@ts-ignore
import { useBreakpoints } from "@wkComposables/useBreakpoints";
var modalSizes = ["modal-sm", "modal-md", "modal-lg", "modal-xl", "modal-xxl", "modal-desktop"];
export default defineComponent({
  components: {
    BaseButton,
    CloseIcon
  },
  props: {
    id: {
      type: String,
      default: "base-bt-modal"
    },
    size: {
      type: String,
      default: "modal-md"
    },
    customBackdropClasses: {
      type: String,
      default: ""
    },
    customModalClasses: {
      type: String,
      default: ""
    },
    customModalDialogClasses: {
      type: String,
      default: ""
    },
    customModalContentClasses: {
      type: String,
      default: ""
    },
    customModalHeaderClasses: {
      type: [String, Array],
      default: ""
    },
    customModalBodyClasses: {
      type: String,
      default: ""
    },
    customModalFooterClasses: {
      type: String,
      default: ""
    },
    withCustomFooter: {
      type: Boolean,
      default: false
    },
    withCloseIcon: {
      type: Boolean,
      default: true
    },
    showModal: {
      type: Boolean,
      required: true
    },
    closeIcon: {
      type: String,
      default: ""
    },
    headerTitle: {
      type: String,
      default: ""
    },
    autoClose: {
      type: Number
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    closeOnClickOut: {
      type: Boolean,
      default: true
    }
  },
  emits: ["closed", "opened"],
  setup() {
    var {
      isSmall: isMobile
    } = useBreakpoints();
    return {
      isMobile
    };
  },
  data() {
    return {
      baseModalMaxWidthClass: "",
      clickStartedInChild: false
    };
  },
  computed: {
    backdropEl() {
      return this.$refs.backdropEl;
    },
    modalEl() {
      return this.$refs.modalEl;
    }
  },
  watch: {
    showModal(newVal) {
      if (!newVal) {
        this.closeModal();
      }
    }
  },
  created() {
    document.body.classList.add("tw-no-scrolling", "sm:tw-pr-15px");
  },
  unmounted() {
    document.body.classList.remove("tw-no-scrolling", "sm:tw-pr-15px");
  },
  mounted() {
    var _a;
    this.openModal();
    var onKeyDownHandler = event => {
      var _a;
      if (event.key === "Escape") {
        this.closeModal();
        (_a = document.body) === null || _a === void 0 ? void 0 : _a.removeEventListener("keydown", onKeyDownHandler);
      }
    };
    (_a = document.body) === null || _a === void 0 ? void 0 : _a.addEventListener("keydown", onKeyDownHandler);
  },
  methods: {
    handleMouseDown(e) {
      if (!this.modalEl) return;
      if (this.modalEl.contains(e.target)) this.clickStartedInChild = true;
    },
    handleMouseUp(e) {
      if (!this.modalEl) return;
      if (this.modalEl.contains(e.target)) this.clickStartedInChild = false;
    },
    /** Opens the modal with a transition */
    openModal() {
      return __awaiter(this, void 0, void 0, function* () {
        //Open the modal!
        var backdropEl = this.backdropEl;
        var modalEl = this.modalEl;
        //The modal is initially transparent...
        backdropEl === null || backdropEl === void 0 ? void 0 : backdropEl.classList.add("tw-flex", "colored-backdrop");
        var modalDialogClasses = this.customModalDialogClasses || "";
        modalDialogClasses += " ".concat(this.size);
        var modalMaxWidth = modalDialogClasses.split(" ").find(token => modalSizes.includes(token));
        modalEl === null || modalEl === void 0 ? void 0 : modalEl.classList.add("show", "base-".concat(modalMaxWidth));
        /* Closing the modal in a given interval */
        if (this.autoClose !== undefined) {
          setTimeout(() => {
            this.closeModal();
          }, this.autoClose);
        }
      });
    },
    closeOnBackdropClick(_ref) {
      var {
        target
      } = _ref;
      return __awaiter(this, void 0, void 0, function* () {
        if (!this.closeOnClickOut || this.isMobile && !target.classList.contains("bbt-modal-wrapper") ||
        //In mobile mode, the wrapper will be touched
        !this.isMobile && !target.classList.contains("bbt-backdrop") //In desktop mode, the backdrop will be clicked
        ) return;
        if (this.clickStartedInChild) {
          this.clickStartedInChild = false;
          return;
        }
        //Closing the modal iff the user clicks on the backdrop!
        yield this.closeModal();
      });
    },
    /** Closes the modal with a transition */
    closeModal() {
      return __awaiter(this, void 0, void 0, function* () {
        this.backdropEl.classList.remove("colored-backdrop");
        this.backdropEl.classList.add("tw-flex", "tw-bg-transparent");
        this.modalEl.classList.remove("show");
        this.modalEl.classList.add("closed", "tw-overflow-hidden");
        document.body.classList.remove("no-scrolling");
        yield awaitableSetTimeout(() => {
          //Closing the modal!
          this.$emit("closed");
        }, 250);
      });
    },
    onClosed() {
      return __awaiter(this, void 0, void 0, function* () {
        //Awaiting the closure of the modal and then firing the closed event!
        yield this.closeModal();
        this.$emit("closed");
      });
    },
    onOpened() {
      return __awaiter(this, void 0, void 0, function* () {
        yield this.openModal();
        this.$emit("opened");
      });
    }
  }
});